import { css, html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';

const tagName = 'support-agent-cursor';

/**
 * Adapted from [Banno's implementation](https://github.com/Banno/platform-ux/blob/master/projects/banno-online/src/components/bannoweb/shared/support-agent-cursor.js)
 * of a support agent cursor.
 */
export class SupportAgentCursor extends LitElement {
    public static tagName = tagName;

    public static readonly styles = css`
        :host {
            position: absolute;
            text-align: center;
            border-top-left-radius: 0;
            border-top-right-radius: 40px;
            border-bottom-right-radius: 40px;
            border-bottom-left-radius: 40px;
            border: 1px solid;
            background-color: var(--jha-button-background, var(--jha-color-primary, #006ee4));
            color: var(--jha-button-text, var(--jha-text-white, #ffffff));
            border-color: var(--jha-button-text, var(--jha-text-white, #ffffff));
            font-weight: var(--jha-button-default-font-weight, 400);
            font-size: var(--jha-button-default-font-size, 14px);
            padding: 8px;
            transition: all 0.2s ease-in-out;
            z-index: 101;
            box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.33);
        }
    `;

    @property({ type: String })
    public agentName = 'Agent';

    public render() {
        return html`${this.agentName} `;
    }
}

export function defineSupportAgentCursor() {
    if (!customElements.get(tagName)) {
        customElements.define(tagName, SupportAgentCursor);
    }
}
